export const shouldSuppressGlobalErrorToast = (error: unknown) => {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  if ('status' in error && (error as { status?: unknown }).status === 401) {
    return true;
  }

  // Auth0's silent-auth check throws this when the cached session/refresh token
  // has expired. AuthWall already redirects off `isAuthenticated`, so it's the
  // pre-login equivalent of a 401, not a real query failure.
  if ('error' in error && (error as { error?: unknown }).error === 'login_required') {
    return true;
  }

  return false;
};
